import { render } from "./QuestionAddModal.vue?vue&type=template&id=e61b5b58"
import script from "./QuestionAddModal.vue?vue&type=script&lang=js"
export * from "./QuestionAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/srv/volumes/sshfs-rpi3ex/bilimcert/v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__